import aira1 from "./AIRA (1).png";
import aira2 from "./AIRA (2).png";
import byra1 from "./BYRA (1).png";
import byra2 from "./BYRA (2).png";
import celia1 from "./CELIA (1).png";
import celia2 from "./CELIA (2).png";
import elysia1 from "./ELYSIA (1).png";
import elysia2 from "./ELYSIA (2).png";
import kiana1 from "./LYRA (Danau).png";
import kiana2 from "./LYRA (Danau) (2).png";
import kiana3 from "./KIANA.png";
import nara1 from "./Nara.png";
import nara2 from "./NARA (Danau).png";
import nara3 from "./MIRABELLA.png";

const Aira = [aira1, aira2];
const Byra = [byra1, byra2];
const Celia = [celia1, celia2];
const Elysia = [elysia1, elysia2];
const Kiana = [kiana1, kiana2, kiana3];
const Nara = [nara1, nara2, nara3];

export { Aira, Byra, Celia, Elysia, Kiana, Nara };
